import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import FactorServices from "./Factor.services";
import { ResponsiveEmbed } from "react-bootstrap";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetFactor = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR,
      payload: true,
    });
    dispatch({
      type: actions.GET_FACTOR,
      payload: {
        factors: [],
        factorsLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FACTOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR,
      payload: false,
    });
  }
};

export const getFactor = (filters, id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR,
      payload: true,
    });
    const resp = await FactorServices.getFactor(filters, id);
    dispatch({
      type: actions.GET_FACTOR,
      payload: {
        factors: id ? resp.data.factores : resp.data.data,
        factorsLength: id ? resp.data.factores.length : resp.data.count,
      },
    });
    dispatch({
      type: actions.FACTOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.FACTOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR,
      payload: false,
    });
  }
};

export const getFactorById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR_BY_ID,
      payload: true,
    });
    const resp = await FactorServices.getFactorById(id);
    dispatch({
      type: actions.GET_FACTOR_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.FACTOR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FACTOR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR_BY_ID,
      payload: false,
    });
  }
};

export const saveFactor = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_FACTOR,
      payload: true,
    });
    const resp = await FactorServices.saveFactor(data);
    const { factors, factorsLength } = getState().factor;
    const _factors = [...factors, resp.data];
    dispatch({
      type: actions.GET_FACTOR,
      payload: {
        factors: _factors,
        factorsLength: factorsLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_FACTOR,
      payload: false,
    });
  }
};

export const editFactor = (data, id, index, setShowModal, id_encabezado) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR,
      payload: true,
    });
    const resp = await FactorServices.editFactor(id, data, id_encabezado);
    const { factors, factorsLength } = getState().factor;
    if (id_encabezado) {
      factors[index].peso = data.cambio_pesos[0].peso;
    } else {
      factors[index] = resp.data;
    }

    dispatch({
      type: actions.GET_FACTOR,
      payload: {
        factors: factors,
        factorsLength: factorsLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR,
      payload: false,
    });
  }
};

export const deleteFactor = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_FACTOR,
      payload: true,
    });
    await FactorServices.deleteFactor(id);
    const { factors, factorsLength } = getState().factor;
    factors.splice(index, 1);
    dispatch({
      type: actions.GET_FACTOR,
      payload: {
        factors: factors,
        factorsLength: factorsLength - 1,
      },
    });
    dispatch({
      type: actions.FACTOR_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data&&ex.response.data[0]){
              message = ex.response.data[0];
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_FACTOR,
      payload: false,
    });
  }
};
